import React, { useState, useEffect } from 'react';
import {
  Alert,
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  Snackbar,
  TextField,
} from '@mui/material';
import {
  ArrowBackRounded,
  ChevronRightRounded,
} from '@mui/icons-material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Zoom from 'react-medium-image-zoom';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import Elements from '../../../Elements';
import Images from '../../../../Configs/images';
import 'react-medium-image-zoom/dist/styles.css';
import ROUTES from '../../../../Configs/routes';
import { getAddress } from '../../../../Redux/Models/address';
import { getCategories, getConditions } from '../../../../Redux/Models/master';
import { getUserData } from '../../../../Utils/storages';
import { getItemDetails } from '../../../../Redux/Models/market';
import { createRequestOut } from '../../../../Redux/Models/request';
import { onlyNumbers } from '../../../../Utils/helpers';

export default function RequestStorage({
  classes, error, message, newRO, isLoading,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const userData = getUserData();
  const { productId } = useParams();
  const [activeStep, setActiveStep] = useState(1);
  const [wantToCancel, setWantToCancel] = useState(false);
  const [ROConfirm, setROConfirm] = useState(false);

  const { address, master } = useSelector((state) => state);

  const [selectAddress, setSelectAddress] = useState(false);
  const [fields, setFields] = useState({
    owner: '',
    phone_number: '',
    owner_address: {},
    pickup_address: {},
    pickup_date: new Date(),
    pickup_notes: '',
    amount: 0,
    notes: '',
    item_notes: '',
    category_id: '-',
    condition_id: '-',
    left_code: '',
    right_code: '',
  });

  const handleChangeField = ({ target }) => {
    setFields({
      ...fields,
      [target.name]: target.value,
    });
  };

  const handleChangeBoxCode = ({ target }) => {
    const newVal = onlyNumbers(target.value);
    if (newVal.length <= 4) {
      setFields({
        ...fields,
        [target.name]: newVal,
      });
    }
  };

  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const closeSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  useEffect(() => {
    if (error) {
      setSnackbar({
        open: true,
        message: `Something went wrong. ${message}`,
        severity: 'error',
      });
    }
  }, [error]);

  useEffect(() => {
    if (newRO) {
      navigate(ROUTES.myStorages(), {
        state: {
          open: true,
          message: 'Request out proceed',
          severity: 'success',
        },
      });
    }
  }, [newRO]);

  useEffect(() => {
    dispatch(getAddress(userData.id));
    dispatch(getCategories());
    dispatch(getConditions());
  }, []);

  useEffect(() => {
    if (address.data.length) {
      const selectedAddress = address.data.filter((addr) => addr.is_default)[0];
      setFields({
        ...fields,
        owner_address: selectedAddress,
      });

      if (!fields.pickup_address.address) {
        setFields({
          ...fields,
          pickup_address: selectedAddress,
        });
      }
    }
  }, [address]);

  useEffect(() => {
    if (location.state) {
      const owner = userData.back_name ? `${userData.front_name} ${userData.back_name}` : userData.front_name;
      setFields({
        ...fields,
        ...location.state,
        owner,
        phone_number: userData.phone_number,
      });
    }
  }, [location.state]);

  const toggleSelectAddress = () => {
    setSelectAddress(!selectAddress);
  };

  const toggleROConfirmation = () => {
    setROConfirm(!ROConfirm);
  };

  const selectPickupAddress = (adrs) => {
    setFields({
      ...fields,
      pickup_address: adrs,
    });
    toggleSelectAddress();
  };

  const toggleCancelConfirmation = () => {
    setWantToCancel(!wantToCancel);
  };

  useEffect(() => {
    if (!productId) {
      navigate(ROUTES.myStorages());
    } else {
      dispatch(getItemDetails(userData.id, productId));
    }
  }, [productId]);

  const stepBack = () => {
    setActiveStep(activeStep - 1);
  };

  const getImage = (name, step) => {
    if (step === activeStep) return Images[`${name}Active`];
    if (step > activeStep) return Images[name];
    return Images.Check;
  };

  const wantToContinue = () => {
    let valid = false;
    switch (activeStep) {
      case 1: valid = fields.owner && fields.phone_number && fields.owner_address?.address;
        break;
      case 2: valid = true;
        break;
      case 3: valid = fields.pickup_date
      && fields.pickup_notes
      && fields.pickup_address?.id
      && fields.left_code?.length === 4
      && fields.right_code?.length === 4;
        break;
      default: valid = false;
    }

    if (valid) {
      setActiveStep(activeStep + 1);
    } else {
      setSnackbar({
        open: true,
        message: 'Please complete the form!',
        severity: 'error',
      });
    }
  };

  const handleProceedRO = () => {
    const body = {
      ...fields,
      pickup_date: new Date(fields.pickup_date),
      owner_address: fields.owner_address.id,
      pickup_address: fields.pickup_address.id,
      amount: Number(fields.amount),
      type: 'Request Out',
    };
    dispatch(createRequestOut(userData.id, productId, body));
  };

  const renderAddressList = () => {
    if (address.data.length) {
      return (
        <div className="mt-2">
          {address.data.map((adrs, index) => (
            <Box className="address-card" key={index} onClick={() => selectPickupAddress(adrs)}>
              <div className="flex space-between align-items-center">
                <div className="s-12 weight-700">
                  Address
                  {' '}
                  {index + 1}
                </div>
                <div hidden={!address.is_default} className="main-address s-14 weight-500 white">
                  Main address
                </div>
              </div>
              <div className="mt-3 s-16 weight-400">
                {adrs.address}
                ,
                {' '}
                {adrs.city}
                ,
                {' '}
                {adrs.province}
                ,
                {' '}
                {adrs.country}
                ,
                {' '}
                {adrs.postal_code}
              </div>
            </Box>
          ))}
        </div>
      );
    }

    return null;
  };

  return (
    <Elements.PageBase noNav>
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={snackbar.open} autoHideDuration={10000} onClose={closeSnackbar}>
        <Alert onClose={closeSnackbar} severity={snackbar.severity || 'success'}>
          {snackbar.message}
        </Alert>
      </Snackbar>
      <div className={classes.root}>
        <Container>
          <div className="flex align-items-center">
            <IconButton sx={{ p: 0 }} onClick={toggleCancelConfirmation}>
              <ArrowBackRounded className="black" />
            </IconButton>
            <h4>Request return</h4>
          </div>
          <div className="mt-4">
            <div className="flex space-between align-items-center">
              <div className="center">
                <img src={getImage('Person', 1)} alt="Owner data" />
                <div className={`mt-1 s-12 ${activeStep === 1 && 'linear-red-text weight-700'}`}>Owner data</div>
              </div>
              <img src={Images.Divider} alt="Divider" />
              <div className="center">
                <img src={getImage('DataCheck', 2)} alt="Item data" />
                <div className={`mt-1 s-12 ${activeStep === 2 && 'linear-red-text weight-700'}`}>Item data</div>
              </div>
              <img src={Images.Divider} alt="Divider" />
              <div className="center">
                <img src={getImage('Calendar', 3)} alt="delivery" />
                <div className={`mt-1 s-12 ${activeStep === 3 && 'linear-red-text weight-700'}`}>Delivery info</div>
              </div>
              <img src={Images.Divider} alt="Divider" />
              <div className="center">
                <img src={getImage('AllCheck', 4)} alt="Confirmation" />
                <div className={`mt-1 s-12 ${activeStep === 4 && 'linear-red-text weight-700'}`}>Confirmation</div>
              </div>
            </div>
          </div>

          <div className="mt-4">

            <form>
              <div className="form-section" hidden={activeStep !== 1}>
                <div className="flex space-between">
                  <h4>Owners data</h4>
                  <IconButton sx={{ p: 0 }} onClick={() => navigate(`${ROUTES.profile()}/update`)}>
                    <img src={Images.Write} alt="write" />
                  </IconButton>
                </div>
                <label className="mt-3">Name</label>
                <TextField disabled value={fields.owner} placeholder="No name" fullWidth />
                <label className="mt-3">Phone number</label>
                <TextField disabled value={fields.phone_number} placeholder="No phone number" fullWidth />
                <label className="mt-3">Home address</label>
                <TextField disabled value={fields.owner_address?.address} placeholder={address.isLoading ? 'Loading...' : 'No address'} fullWidth />
                <div className="floating-action">
                  <Container>
                    <Button fullWidth size="large" variant="contained" className="btn-contained" onClick={wantToContinue}>
                      Next
                    </Button>
                  </Container>
                </div>
              </div>

              <div className="form-section" hidden={activeStep !== 2}>
                <div>
                  <h4>Item data</h4>
                </div>

                <div className="mt-3">
                  <div className="s-12">Item amounts</div>
                  <div className="height-14 weight-500">
                    {fields.amount}
                    {' '}
                    Items
                  </div>
                </div>
                <div className="mt-3">
                  <div className="s-12">Notes</div>
                  <div className="height-14 weight-500">{fields.notes || '-'}</div>
                </div>
                <div className="mt-3">
                  <div className="s-12">Category</div>
                  <div className="height-14 weight-500">{master.categories.filter((cat) => cat.id === fields.category_id)[0]?.name}</div>
                </div>
                <div className="mt-3">
                  <div className="s-12">Condition</div>
                  <div className="height-14 weight-500">{master.conditions.filter((con) => con.id === fields.condition_id)[0]?.name}</div>
                </div>

                <div className="mt-3">
                  <div className="s-12">Photo</div>
                  <Zoom>
                    <img
                      src={fields.photo}
                      alt="testasset"
                      width="120"
                      height="120"
                      className="rounded mt-2"
                    />
                  </Zoom>
                </div>
                <div className="floating-action">
                  <Container>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Button fullWidth size="large" variant="outlined" className="btn-outlined" onClick={stepBack}>
                          Back
                        </Button>
                      </Grid>
                      <Grid item xs={6}>
                        <Button fullWidth size="large" variant="contained" className="btn-contained" onClick={wantToContinue}>
                          Next
                        </Button>
                      </Grid>
                    </Grid>
                  </Container>
                </div>
              </div>

              <div className="form-section" hidden={activeStep !== 3}>
                <div>
                  <h4>Delivery info</h4>
                </div>
                <label className="mt-3">Date</label>
                <TextField type="datetime-local" fullWidth value={fields.pickup_date} name="pickup_date" onChange={handleChangeField} />
                <label className="mt-3">Notes</label>
                <TextField placeholder="Please on time. I wanna go outside" fullWidth value={fields.pickup_notes} name="pickup_notes" onChange={handleChangeField} />
                <label className="mt-3">Delivery address</label>
                <TextField
                  fullWidth
                  disabled
                  onChange={handleChangeField}
                  value={fields.pickup_address.address}
                  InputProps={{
                    endAdornment: (
                      <IconButton sx={{ p: 0 }} onClick={toggleSelectAddress}>
                        <ChevronRightRounded />
                      </IconButton>
                    ),
                  }}
                />

                <h4 className="mt-3">Box code</h4>
                <label className="mt-1">Left code</label>
                <TextField placeholder="Four digit code. Ex: 1234" fullWidth value={fields.left_code} name="left_code" onChange={handleChangeBoxCode} />
                <label className="mt-3">Right code</label>
                <TextField placeholder="Four digit code. Ex: 4321" fullWidth value={fields.right_code} name="right_code" onChange={handleChangeBoxCode} />

                <div className="floating-action">
                  <Container>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Button fullWidth size="large" variant="outlined" className="btn-outlined" onClick={stepBack}>
                          Back
                        </Button>
                      </Grid>
                      <Grid item xs={6}>
                        <Button fullWidth size="large" variant="contained" className="btn-contained" onClick={wantToContinue}>
                          Next
                        </Button>
                      </Grid>
                    </Grid>
                  </Container>
                </div>
              </div>

              <div className="form-section" hidden={activeStep !== 4}>
                <div>
                  <h4>Confirmation</h4>
                </div>

                <div className="mt-4">
                  <div className="s-16 weight-600">Owner data</div>
                  <div className="mt-3">
                    <div className="s-12">Name</div>
                    <div className="height-14 weight-500">{fields.owner}</div>
                  </div>
                  <div className="mt-3">
                    <div className="s-12">Phone number</div>
                    <div className="height-14 weight-500">{fields.phone_number}</div>
                  </div>
                  <div className="mt-3">
                    <div className="s-12">Address</div>
                    <div className="height-14 weight-500">{fields.owner_address?.address}</div>
                  </div>
                </div>

                <div className="mt-4">
                  <div className="s-16 weight-600">Item info</div>
                  <div className="mt-3">
                    <div className="s-12">Item amounts</div>
                    <div className="height-14 weight-500">
                      {fields.amount}
                      {' '}
                      Items
                    </div>
                  </div>
                  <div className="mt-3">
                    <div className="s-12">Notes</div>
                    <div className="height-14 weight-500">{fields.notes || '-'}</div>
                  </div>
                  <div className="mt-3">
                    <div className="s-12">Category</div>
                    <div className="height-14 weight-500">{master.categories.filter((cat) => cat.id === fields.category_id)[0]?.name}</div>
                  </div>
                  <div className="mt-3">
                    <div className="s-12">Condition</div>
                    <div className="height-14 weight-500">{master.conditions.filter((con) => con.id === fields.condition_id)[0]?.name}</div>
                  </div>
                </div>

                <div className="mt-4">
                  <div className="s-16 weight-600">Pickup info</div>
                  <div className="mt-3">
                    <div className="s-12">Date</div>
                    <div className="height-14 weight-500">{moment(fields.pickup_date).format('HH.mm - DD-MM-YYYY')}</div>
                  </div>
                  <div className="mt-3">
                    <div className="s-12">Notes</div>
                    <div className="height-14 weight-500">{fields.pickup_notes || '-'}</div>
                  </div>
                  <div className="mt-3">
                    <div className="s-12">Address</div>
                    <div className="height-14 weight-500">{fields.pickup_address?.address}</div>
                  </div>
                </div>

                <div className="floating-action">
                  <Container>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Button fullWidth size="large" variant="outlined" className="btn-outlined" onClick={stepBack}>
                          Back
                        </Button>
                      </Grid>
                      <Grid item xs={6}>
                        <Button fullWidth size="large" variant="contained" className="btn-contained" onClick={toggleROConfirmation}>
                          Confirm
                        </Button>
                      </Grid>
                    </Grid>
                  </Container>
                </div>
              </div>
            </form>
          </div>
        </Container>

      </div>

      <Elements.ConfirmationModal
        open={wantToCancel}
        desc={(
          <div>
            Are you sure want to cancel?
            <br />
            your progress will not be saved
          </div>
        )}
        handleAgree={() => navigate(-1)}
        handleClose={toggleCancelConfirmation}
      />

      <Elements.ConfirmationModal
        open={ROConfirm}
        desc={(
          <div>
            Make sure all of the Request Out
            <br />
            item data is correct and filled up!
          </div>
        )}
        handleAgree={handleProceedRO}
        handleClose={toggleROConfirmation}
        isLoading={isLoading}
      />

      <Elements.ModalBase open={selectAddress} handleClose={toggleSelectAddress} noAgree maxWidth="xs">
        <div className={classes.address}>
          {renderAddressList()}
        </div>
      </Elements.ModalBase>
    </Elements.PageBase>
  );
}
